/**
 * @generated SignedSource<<2db5c558ecd68390c5397b9de3171efd>>
 * @relayHash c3c857618743a13eb8fe0696462cba60
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 28bb3c6f8f1e51f474d926b3e4f2f9f360538e242a7ab958906aef7b96993d1d

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type combinedInviterNotifSlackPref_personalSettingsDigestNotificationsMutation$variables = {
  cloudId: string;
  isEnabled: boolean;
};
export type combinedInviterNotifSlackPref_personalSettingsDigestNotificationsMutation$data = {
  readonly jira: {
    readonly updateGlobalNotificationPreferences: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly preferences: {
        readonly " $fragmentSpreads": FragmentRefs<"combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_slackFragment">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type combinedInviterNotifSlackPref_personalSettingsDigestNotificationsMutation = {
  response: combinedInviterNotifSlackPref_personalSettingsDigestNotificationsMutation$data;
  variables: combinedInviterNotifSlackPref_personalSettingsDigestNotificationsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "fields": [
      {
        "items": [
          {
            "fields": [
              {
                "kind": "Literal",
                "name": "channel",
                "value": "SLACK"
              },
              {
                "kind": "Variable",
                "name": "isEnabled",
                "variableName": "isEnabled"
              },
              {
                "kind": "Literal",
                "name": "type",
                "value": "PROJECT_INVITER_NOTIFICATION"
              }
            ],
            "kind": "ObjectValue",
            "name": "preferences.0"
          }
        ],
        "kind": "ListValue",
        "name": "preferences"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "combinedInviterNotifSlackPref_personalSettingsDigestNotificationsMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateGlobalPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_slackFragment"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "combinedInviterNotifSlackPref_personalSettingsDigestNotificationsMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateGlobalPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "projectInviterNotification",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "concreteType": "JiraNotificationChannel",
                        "kind": "LinkedField",
                        "name": "slackChannel",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "28bb3c6f8f1e51f474d926b3e4f2f9f360538e242a7ab958906aef7b96993d1d",
    "metadata": {},
    "name": "combinedInviterNotifSlackPref_personalSettingsDigestNotificationsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3f2e2a75758bb062e1be491291a15902";

export default node;
